

<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card card-body card-panel-box border-0">
        <div class="row d-flex justify-content-start">
          <h2 style="font-size: 1.2vw !important;">دانش</h2>
        </div>
        <form class="needs-validation mt-2 mb-3" novalidate>
          <div class="row">
            <div class="col-lg-2 mb-3 ms-n-1">
              <label class="form-label"> شرح دانش								    </label>
              <input v-model="title" class="form-control" type="text" name="" required>
            </div>
            <div class="col-lg-2-5 mb-3 ms-n-1">
              <label class="form-label">مرجع دانش	      </label>
              <input v-model="reference" class="form-control" type="text" name="" required>

            </div>
            <div class="col-lg-2 mb-3 ms-n-1">
              <label class="form-label">متولی ثبت		</label>
              <input v-model="trustee" class="form-control" type="text" name="" required>

            </div>
            <div class="col-lg-2 mb-3 ms-n-1">
              <label class="form-label">نوع دانش  		  </label>
              <input v-model="type" class="form-control" type="text" name="" required>

            </div>
            <div class="col-lg-2-5 mb-3 ms-n-1">
              <label class="form-label">مشتری دانش			</label>
              <input v-model="customer" class="form-control" type="text" name="" required>

            </div>
            <div class="col-lg-1 mb-3">
              <button v-show="!editModal" @click.prevent="saveItem" class="btn btn-primary btn-submit-1" type="submit"
                      style="width: 2vw;margin-top: 1.9vw; font-size: 2vw; transform: translateX(-9vw)">
                <span style="transform: translateY(.2vw) ">+</span>
              </button>
              <button v-show="editModal" @click.prevent="update(item_id)" class="btn btn-primary btn-submit-1" type="submit"
                      style="margin-top: 1.9vw; font-size: 1vw; transform: translateX(-6vw); width: 4vw;">
                <span style="">ویرایش</span>
              </button>            </div>
          </div>
          <hr>
        </form>
        <div class="table-responsive">
          <center v-show="!all_items.length">
            <p> دانش  وجود ندارد</p>
          </center>
          <table v-show="all_items.length" class="table table-striped">
            <thead>
            <tr>
              <th>ردیف</th>
              <th>شرح دانش    </th>
              <th>مرجع دانش      </th>
              <th>متولی ثبت</th>
              <th>نوع دانش</th>
              <th>مشتری دانش</th>
              <th>عملیات</th>
            </tr>
            </thead>
            <tbody>
            <tr  v-for="(item,index) in all_items">
              <td scope="row">{{index+1}}</td>
              <td>{{item.title}}</td>
              <td>{{item.reference}}</td>
              <td>{{item.trustee}}</td>
              <td>{{item.type}}</td>
              <td>{{item.customer}}</td>

              <td>
                <a @click.prevent="edit(item.id)" href="#"><img class="table-edit-img" src="/img/pen.6428fd02.svg" alt="edit"></a>
                <a @click.prevent="deleteModalMethod(item.id)" href="#"><img class="table-delete-img mx-2" src="/img/delete.f9fc94bc.svg" alt="delete"> </a>
              </td>
            </tr>

            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <div dir="rtl" class="modal__error slide-top" v-show="deleteModal" style="z-index: 999999999999999; top: 95%;">
    <div>
      <p>حذف</p>
      <p @click="deleteModal=!deleteModal">❌</p>
    </div>
    <div>
      <p>آیا میخواهید حذف کنید!</p>

      <div class="form-buttons row d-flex justify-content-around mt-5 mb-3" style="width: 20vw;">
        <button @click="deleteModal=!deleteModal" class="btn btn-primary btn-back" type="submit">برگشت</button>
        <button class="btn btn-primary btn-approve" @click="deleteItemForm(item_id)">تایید</button>
      </div>
    </div>
  </div>
  <!-- modal  -->
  <!-- modal -->
  <div dir="rtl" class="modal__error slide-top" v-show="error"
       style="z-index: 999999999999999999999999999999999999999999999; top: 25%;">
    <div>
      <p>   خطا  </p>
      <p @click="error=!error">❌</p>
    </div>
    <div>
      {{errorMessage}}



      <button @click="error=!error">بازگشت</button>
    </div>
  </div>
</template>
<script >
export  default {
  props: ['id_route'],

  data(){

    return{
      title: '',
      reference: '',
      trustee: '',
      type: '',
      customer: '',
      item_id: '',
      all_items: [],
      error: false,
      errorMessage: false,
      deleteModal: false,
      editModal: false,

    }
  },
  methods:{
    deleteModalMethod(id){
      this.item_id=id
      this.deleteModal=true
    },
    deleteItemForm(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Knowledge_process/destroy/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.deleteModal=false


          })
          .catch();
    },
    edit(id){
      this.item_id=id
      this.editModal=true
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Knowledge_process/edit/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            const item = response.item
            if (item){
              this.title=item.title
              this.reference=item.reference
              this.trustee=item.trustee
              this.type=item.type
              this.customer=item.customer

            }




          })
          .catch();
    },
    update(id){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();

      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('reference', this.reason)
      formdata.append('trustee', this.consequences)
      formdata.append('type', this.type)
      formdata.append('customer', this.opportunity)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Knowledge_process/update/${id}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()

            this.processes_id=''
            this.title=''
             this.reference=''
            this.trustee=''
            this.type=''
            this.customer=''

            this.editModal=false



          })
          .catch();
    },
    saveItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);


      var formdata = new FormData();
      formdata.append('processes_id', this.id_route)
      formdata.append('title', this.title)
      formdata.append('reference', this.reference)
      formdata.append('trustee', this.trustee)
      formdata.append('type', this.type)
      formdata.append('customer', this.customer)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Knowledge_process/store`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = true

              this.errorMessage = response.error.replace("and", '').replace('errors', 'فیلد الزامی است  ').replace("more ", '')
              return;
            }
            this.showItem()
            this.processes_id=''
            this.title=''
            this.reference=''
            this.trustee=''
            this.type=''
            this.customer=''

          })
          .catch();

    },
    showItem() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Knowledge_process/all/${this.id_route}`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.all_items.length=0
              response.all.forEach((item)=>{
                this.all_items.push(item)
              })

            }


          })
          .catch();

    },

  },
  mounted() {
    this.showItem()

  }
}
</script>

<style scoped>
.table-striped > tbody > tr:nth-of-type(odd) {
  --bs-table-accent-bg: #D0E9FA57;
  color: var(--bs-table-striped-color);
}
</style>